export enum RaceDisplayType {
  Unknown,
  Starters,
  Results,
}
